var plugin_rtlignore_default = {
  "alignLeft": "_2x9-h",
  "textWrapNowrap": "pXFSs",
  "alignRight": "_2dDS1",
  "alignCenter": "DyPY-",
  "sizeFullWidth": "UadAx",
  "renderedInTable": "CveZi",
  "sizeOriginal": "rqzEe",
  "sizeContent": "_89fZr",
  "sizeSmall": "fvl-t",
  "sizeSmallCenter": "VUtBy",
  "flex": "lMdcE",
  "atomic": "zwvub",
  "embed": "HdV-z",
  "horizontalScrollbar": "_9wn6I",
  "pluginContainerMobile": "fch0R"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
